import React, { forwardRef } from "react";
import { CurrencyInput } from "react-currency-mask";
import { MessageError } from "../common";
import { cn } from "@/lib";

type MoneyInputProps = React.InputHTMLAttributes<HTMLInputElement> & {
  isInvalid?: boolean | string | null;
  isValid?: boolean | string | null;
  messageError?: string;
  defaultValue?: string | number;
  showError?: boolean;
};

const MoneyInput = forwardRef<HTMLInputElement, MoneyInputProps>(
  (
    {
      isInvalid,
      isValid,
      messageError,
      showError = true,
      className,
      defaultValue,
      onChange,
      ...props
    },
    ref
  ) => {
    const inputClasses = cn(
      "flex h-10 w-full rounded-md border border-input bg-background px-4 py-2 text-base ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-500/35 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
      className,
      {
        "is-invalid": isInvalid,
        "is-valid": isValid,
      }
    );
    return (
      <div className="space-y-1">
        <CurrencyInput
          ref={ref}
          onChangeValue={(event, originalValue) => {
            const e = {
              target: {
                name: event.currentTarget.name,
                value: originalValue,
              },
            };
            onChange?.(e as any);
          }}
          defaultValue={defaultValue}
          InputElement={<input ref={ref} className={inputClasses} {...props} />}
        />
        {showError && isInvalid && (
          <MessageError isInvalid={isInvalid} messageError={messageError} />
        )}
      </div>
    );
  }
);

MoneyInput.displayName = "MoneyInput";

export { MoneyInput };
